import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// if user is log in go to home page and not go to registration or login page
export function UserStatusGoPage(page) {
    const login = useSelector((state) => state.userIsLogIn.value);
    // const answerQuestion = useSelector((state) => state.userIsLogIn.value);
    let navigate = useNavigate();
    const choose = useSelector((state) => state.chooseCategory.value);
    useEffect(() => {

        // if user is loged in and choose category go to home page else go to question page 
        if (login.isLogIn && !choose.choose) {
            return navigate("/choose-category");
        } else if (login.isLogIn && choose.choose) {
            return navigate(page);
        } else if (!login.isLogIn) {
            return navigate("/login");
        }
    }, [login])
}

// if user is not log in go to login page
// export function UserStatusGoLoginPage() {
//     const login = useSelector((state) => state.userIsLogIn.value);
//     let navigate = useNavigate();
//     useEffect(() => {
//         if (!login.isLogIn) {
//             return navigate("/login");
//         }
//     }, [login])
// }